import { Navigate, Route, Routes } from "react-router-dom";
import { HomePage } from "@/pages/Home/HomePage";
import { LoginPage } from "@/pages/Login/LoginPage";
import { RegisterStudentPage } from "@/pages/RegisterStudent/RegisterStudentPage";
import PrivateRoute from "./PrivateRoute.tsx";
import Logout from "./Logout.tsx";
import { ForgotPasswordPage } from "@/pages/ForgotPassword/ForgotPasswordPage";
import { ResetPasswordPage } from "@/pages/ResetPassword/ResetPasswordPage";
import { ConfirmEmailPage } from "@/pages/ConfirmEmail/ConfirmEmailPage";

const PublicRoutes = () => {
  return (
    <Routes>
      <Route path="/home" element={<HomePage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/signup" element={<RegisterStudentPage />} />
      <Route path="/confirm-email" element={<ConfirmEmailPage />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      <Route path="/reset-password" element={<ResetPasswordPage />} />
      <Route path="/logout" element={<PrivateRoute component={Logout} />} />
      <Route path="*" element={<Navigate to="/home" />} />
    </Routes>
  );
};

export default PublicRoutes;
